import { Clock } from "lucide-react";

interface Props {
  label: string;
  title?: string;
  className?: string;
}

/** Eye-catching chip for "posted N days ago" — same pulse/glow treatment as CompanyApplyChip, but a dark/neutral background so it doesn't compete with the amber "Direct to Company" chip. */
export default function TimeAgoChip({ label, title, className }: Props) {
  if (!label) return null;

  return (
    <span
      title={title}
      className={`flex items-center gap-1 text-[10px] px-2 py-1 rounded-full font-inter font-bold text-white bg-gradient-to-r from-slate-800 to-black ring-2 ring-slate-400/40 shadow-[0_0_10px_rgba(148,163,184,0.5)] animate-pulse cursor-default shrink-0 ${className ?? ""}`}
    >
      <Clock className="w-3 h-3" />
      {label}
    </span>
  );
}
